import type { ProratedRentResult } from './types';
import { Month, TenantStatus } from './types';

const MONTH_ARRAY = [
  Month.JANUARY,
  Month.FEBRUARY,
  Month.MARCH,
  Month.APRIL,
  Month.MAY,
  Month.JUNE,
  Month.JULY,
  Month.AUGUST,
  Month.SEPTEMBER,
  Month.OCTOBER,
  Month.NOVEMBER,
  Month.DECEMBER,
];

export default function calculate(tenantStatus: TenantStatus, monthlyRent: number, moveDate: Date): ProratedRentResult {
  // increment month, because day 0 takes you to the last day of the previous month
  const daysInMonth = new Date(moveDate.getFullYear(), moveDate.getMonth() + 1, 0).getDate();

  let proratedRentPeriodStart: Date;
  let proratedRentPeriodEnd: Date;
  if (tenantStatus === TenantStatus.MOVE_IN) {
    proratedRentPeriodStart = moveDate;
    const endOfMonth = new Date(moveDate.getFullYear(), moveDate.getMonth() + 1, 0);
    proratedRentPeriodEnd = endOfMonth;
  } else {
    const startOfMonth = new Date(moveDate.getFullYear(), moveDate.getMonth(), 1);
    proratedRentPeriodStart = startOfMonth;
    proratedRentPeriodEnd = moveDate;
  }

  return {
    dailyRent: monthlyRent / daysInMonth,
    days: proratedRentPeriodEnd.getDate() - proratedRentPeriodStart.getDate() + 1, // include both start and end date
    month: MONTH_ARRAY[moveDate.getMonth()],
  };
}
